import { MantineStyleProps, Paper, PaperProps, Title } from '@mantine/core'
import React from 'react'

interface IPageLayout extends MantineStyleProps, Omit<PaperProps, 'children'> {
    children?: React.ReactNode
    spaceAround?: boolean
    pageTitle?: string
}
const PageLayout = ({
    children,
    pageTitle,
    spaceAround = true,
    ...other
}: IPageLayout) => {
    return (
        <Paper
            mah='100vh'
            pos='relative'
            style={{ overflowY: 'auto', zIndex: 1 }}
            mih='100vh'
            w='100%'
            bg='white'
            p={spaceAround ? 'lg' : '0px'}
            {...other}
        >
            {pageTitle && (
                <Title order={3} p={spaceAround ? '0px' : 'lg'} mb='sm'>
                    {pageTitle}
                </Title>
            )}
            {children}
        </Paper>
    )
}

export default PageLayout
